// UserProfile.jsx - New component for users to view their own transactions
import React, { useState, useEffect } from 'react';
import {
  Container, Card, CardContent, Typography, Box,
  Table, TableBody, TableCell, TableContainer, TableHead,
  TableRow, Paper, Chip
} from '@mui/material';
import api from '../services/api';

const WalletPage = () => {
  const [transactions, setTransactions] = useState([]);
  const [walletInfo, setWalletInfo] = useState(null);

  useEffect(() => {
    fetchUserTransactions();
    fetchUserWallet();
  }, []);

  const fetchUserTransactions = async () => {
    try {
      const response = await api.get('/payment/my-transactions');
      setTransactions(response.data);
    } catch (error) {
      console.error('Error fetching user transactions:', error);
    }
  };

  const fetchUserWallet = async () => {
    try {
      const response = await api.get('/payment/my-wallet');
      setWalletInfo(response.data);
    } catch (error) {
      console.error('Error fetching wallet info:', error);
    }
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 , mb: 10 }}>
      {/* Wallet Summary Card */}
      {walletInfo && (
        <Card sx={{ mb: 3 }}>
          <CardContent>
            <Typography variant="h5" gutterBottom>
              محفظتي
            </Typography>
            <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 2 }}>
              <Box>
                <Typography color="text.secondary">رقم معرف المحفظة</Typography>
                <Typography variant="h6">{walletInfo.wallet_id}</Typography>
              </Box>
              <Box>
                <Typography color="text.secondary">رصيد المحفظة</Typography>
                <Typography variant="h6" color="primary">
                  E.G.P {walletInfo.wallet_balance?.toFixed(2)}
                </Typography>
              </Box>
              <Box>
                <Typography color="text.secondary">نقاط مكتسبة</Typography>
                <Typography variant="h6">
                  {walletInfo.points_balance} نقطة
                </Typography>
              </Box>
              <Box>
                <Typography color="text.secondary">قيمة النقاط</Typography>
                <Typography variant="h6">
                  E.G.P {walletInfo.points_value}
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      )}

      {/* Transactions History */}
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            سجل المعاملات
          </Typography>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>التاريح</TableCell>
                  <TableCell>القيمة</TableCell>
                  <TableCell>نقاط مكتسبة</TableCell>
                  <TableCell>رصيد المحفظة</TableCell>
                  <TableCell>طريقة الدفع</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {transactions.map((tx) => (
                  <TableRow key={tx.id}>
                    <TableCell>
                      {new Date(tx.created_at).toLocaleDateString()}
                    </TableCell>
                    <TableCell>E.G.P {tx.amount}</TableCell>
                    <TableCell>
                      <Chip 
                        label={`+${tx.points_earned} نقطة`} 
                        color="success" 
                        size="small" 
                      />
                    </TableCell>
                    <TableCell>
                      <Chip 
                        label={`+E.G.P ${(tx.points_earned * 0.5).toFixed(2)}`} 
                        color="primary" 
                        size="small" 
                      />
                    </TableCell>
                    <TableCell>
                      {tx.payment_method.replace(/_/g, ' ')}
                    </TableCell>
                  </TableRow>
                ))}
                {transactions.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      <Typography color="text.secondary">
                        لايوجد معاملات
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </Container>
  );
};

export default WalletPage;